import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-dialog-warning',
    templateUrl: './dialog-warning.component.html',
    styleUrls: ['./dialog-warning.component.scss'],
    standalone: false
})
export class DialogWarningComponent implements OnInit {
	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	@Input() loading: boolean;
	@Input() msgVald: number;
	@Input() mainTitle: string;
	@Input() mainMessage: string;

	errorMessage: string = '';
	public _success = new Subject<string>();
	private _error = new Subject<string>();
	successMessage = '';
	constructor(
		public activeModal: NgbActiveModal,
	) { }

	ngOnInit() {
		this.messageValidation();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.msgVald === 1) {
			this._success.next('');
		} else if (this.msgVald === 0) {
			this._error.next('Error: No se pudo realizar la acción intente mas tarde.');
		}
	}
	closeModal() {
		this.activeModal.close('Modal Closed');
	}
	confirmDelete() {
		this.passEntry.emit(true);
	}
	messageValidation() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
}
